import { ArrowRightOutlined, CloseOutlined, EditOutlined, FileDoneOutlined, SearchOutlined, PlusOutlined, PrinterOutlined, FileOutlined, EyeOutlined } from "@ant-design/icons";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, Col, Modal, Row, Space, Tooltip, Select, Form, Input, Tabs, Table, DatePicker } from "antd";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { Controller, set, useForm, useWatch } from "react-hook-form";
import * as yup from "yup";
import * as XLSX from 'xlsx';
import PageHeader from "../../view/pageheader";
import SelectInput from "../CustomComponents/SelectInput";
import TableComponent from "../CustomComponents/TableComponent";
import TextInput from "../CustomComponents/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { getJobsList } from "../../store/reducer/jobSlice";
import { useNavigate } from "react-router-dom";
import { saveAs } from 'file-saver';
import moment from "moment-timezone";
import {
   addPrepTeamQueue,
   getPrepTeamQueue,
   updatePrepTeamQueue,
   resetSuccessFlag,
   prepTeamQueueUsersData,
   addDataAllocation,
   prepDataAllocationById,
   addFileType,
   FileAllType,
   printprepQueueById

} from "../../store/reducer/prepQueueSlice";
import { getUserManagementList } from "../../store/reducer/userManagementSlice";
import { toast } from "react-toastify";
import SearchComponent from "../CustomComponents/SearchComponent";
import { getCustomerList } from "../../store/reducer/customerSlice";
import Loader from "../../fields/Loader/Loader";
import dayjs from "dayjs";




const PrepTeamQueue = () => {
   const [PrepTeamQueueSchema] = useState({
      input_number: "",
      customer_id: null,
      customer_name: "",
   });

   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [type, setType] = useState('add')
   const [editId, setEditId] = useState(null);
   const [managerData, setManagerData] = useState([]);
   const [customerList, setCustomerList] = useState([]);
   const [jobData, setJobData] = useState([]);
   const userId = localStorage.getItem('user_id');
   const role_id = localStorage.getItem("role_id");
   const [fileModal, setFileModal] = useState(false)
   const [addFileMOdal, setAddFileModal] = useState(false)
   const [searchModal, setSearchModal] = useState(false)
   const [searchText, setSearchText] = useState('');
   const [searchDate, setSearchDate] = useState(null);
   const [pendingDownloadId, setPendingDownloadId] = useState(null);
   console.log(editId, "editId==");


   const {
      prepTeamQueueListData,
      addPrepTeamQueueSuccess,
      updatePrepTeamQueueSuccess,
      prepTeamQueueUsersListData,
      AllFileData,
      printprepQueueByIdData,
      addFileTypeSucess, addFileError, addFileErrorMessage, prepTeamQueueLoading
   } = useSelector((state) => state.prepTeamQueue);
   const { userManagementListData, } = useSelector((state) => state.userManagement);
   const { customerListData } = useSelector((state) => state.customers);
   const { jobListData } = useSelector((state) => state.jobs);
   const { count: totalCount, data: tableData } = role_id == 1 || role_id == 2 ? prepTeamQueueListData : prepTeamQueueUsersListData;
   const { count: counts, data: tableFileData } = AllFileData
   const assign_user_id = localStorage.getItem('user_id');
   function getDataProjectManager(payload = {}) {
      dispatch(getUserManagementList(payload));
      dispatch(getCustomerList(payload))
      dispatch(getJobsList(payload));
   }


   useEffect(() => {
      getDataProjectManager();
   }, []);
   useEffect(() => {
      if (jobListData?.data) {
         setJobData(jobListData?.data);
      }
      if (customerListData?.data) {
         setCustomerList(customerListData?.data);
      }
   }, [jobListData]);

   function getData(payload = {}) {
      if (role_id == 1 || role_id == 2) {
         dispatch(getPrepTeamQueue(payload));
         dispatch(FileAllType(payload))
         dispatch(getCustomerList(payload))
         dispatch(getJobsList(payload));
      } else {
         dispatch(prepTeamQueueUsersData({ userId }));
      }

   }
   const validationRules = yup.object().shape({
      input_number: yup
         .number()
         .typeError("Enter a valid number")
         .positive("Number must be greater than zero")
         .integer("Number must be a whole number")
         .required("Enter Number"),
      customer_id: yup.number().typeError("Select Customer Name").required("Select Customer Name"),
      // customer_name: yup.string().required("Enter Customer Name"),
   });

   // const validFileRules = yup.object().shape({
   //    file_type: yup.string().trim().required("File Type is required")
   // })

   const {
      control,
      handleSubmit,
      formState: { errors },
      watch,
      reset,
   } = useForm({
      resolver: yupResolver(validationRules),
      mode: "onChange", // Enable live validation
   });
   const {
      control: fileControl,
      setValue: setFileValue,
      handleSubmit: handleFileSubmit,
      formState: { errors: fileErrors },
      reset: rest
   } = useForm({
      resolver: yupResolver(yup.object().shape({
         file_type: yup.string().trim().required("File Type is required")
      })),
      mode: "onChange",
   });
   const selectedCustomers = useWatch({
      control,
      name: "customer_id",
      defaultValue: editId?.customer_id || [], // set default when editing
   });


   const isCustomerDisabled = editId;
   const inputNumberValue = watch("input_number");
   const customerIdValue = watch("customer_id");
   const [isAddModal, setIsAddModal] = useState(false);
   const [isInputModal, setIsInputModal] = useState(false);
   const [selectedRecord, setSelectedRecord] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const inputAutoFocusRef = useRef(null);
   const [editingFileType, setEditingFileType] = useState(null);
   const [isEditingFile, setIsEditingFile] = useState(false);
   const specIdData = useMemo(() => {
      return jobData
         ?.filter((item) => item?.customer_id == customerIdValue) // Filter data
         .map((item) => ({ label: item?.spec_id, value: item?.id })); // Map to required format
   }, [jobData, customerIdValue]); // Include dependencies correctly
   const customerData = useMemo(() => {
      if (!customerList.length) return [];
      return customerList
         .filter((customer) => customer.status === 1)
         .map((item) => ({
            label: item.customername,
            value: item.id,
         }));
   }, [customerList]);


   useEffect(() => {
      getData();
      if (addPrepTeamQueueSuccess) {
         toast.success("Boxes added successfully");
         setIsAddModal(false); // Close the modal
         reset({ ...PrepTeamQueueSchema }); // Reset the form to the default schema
         dispatch(resetSuccessFlag({ flag: "addPrepTeamQueueSuccess" })); // Reset the success flag
      }
      if (updatePrepTeamQueueSuccess) {
         toast.success("Box count updated successfully.");
         setIsAddModal(false); // Close the modal
         reset({ ...PrepTeamQueueSchema }); // Reset the form to the default schema
         dispatch(resetSuccessFlag({ flag: "updatePrepTeamQueueSuccess" })); // Reset the success flag
      }
   }, [addPrepTeamQueueSuccess, updatePrepTeamQueueSuccess, dispatch, reset, PrepTeamQueueSchema]);

   useEffect(() => {
      if (isAddModal && inputAutoFocusRef.current) {
         setTimeout(() => {
            inputAutoFocusRef.current.focus();
         }, 300);
      }
   }, [isAddModal]);
   useEffect(() => {
      if (type === "edit" && editId) {
         let customerIds = [];
         const balanceBoxes = editId.input_number - (editId.is_completed || 0);

         try {
            // Handle when backend sends JSON string like '["1","2"]'
            if (typeof editId.customer_id === "string") {
               const parsed = JSON.parse(editId.customer_id);
               if (Array.isArray(parsed)) {
                  customerIds = parsed.map((c) =>
                     typeof c === "object" ? c.id : Number(c)
                  );
               }
            }
            // Handle when backend sends array
            else if (Array.isArray(editId.customer_id)) {
               customerIds = editId.customer_id.map((c) =>
                  typeof c === "object" ? c.id : Number(c)
               );
            }
            // Handle when single value
            else if (editId.customer_id) {
               customerIds = [Number(editId.customer_id)];
            }
         } catch {
            customerIds = [];
         }

         reset({
            ...editId,
            customer_id: customerIds,
            // Set the balance as the input_number value
            input_number: balanceBoxes,
         });
      }
   }, [editId, type, reset]);


   const handleDownloadBarcodeExcel = (editId) => {
      setPendingDownloadId(editId);
      dispatch(printprepQueueById({ editId }));
   };
   useEffect(() => {
      if (pendingDownloadId && printprepQueueByIdData.length > 0) {
         const tableData = printprepQueueByIdData.map(({ box_unique_id }) => ({
            "Unique ID": box_unique_id,
         }));

         const worksheet = XLSX.utils.json_to_sheet(tableData);
         const workbook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(workbook, worksheet, "Unique IDs");

         const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
         });

         const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
         });

         saveAs(data, "unique_id_label.xlsx");

         // Reset after download
         setPendingDownloadId(null);
      }
   }, [printprepQueueByIdData]);

   const columns = [
      {
         title: 'Sl.No',
         dataIndex: "id",
         key: "id",
         align: "center",
      },
      {
         title: "Created At",
         dataIndex: "created_at",
         key: "created_at",
         render: (created_at) =>
            moment(created_at).tz("America/New_York").format("MM-DD-YYYY hh:mm A"),
         align: "center",
      },

      {
         title: "No of Boxes",
         dataIndex: "input_number", // Ensure the correct key
         key: "customername",
         align: "center",
      },
      {
         title: "Spec Assigned Boxes",
         dataIndex: "is_completed",
         key: "completed_data",
         align: "center",
         render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
      },
      {
         title: "Customer",
         dataIndex: "customer_name",
         key: "customer_name",
         align: "center",
         render: (value) => {
            if (!value) return "-";

            let customers = [];

            // Normalize into array
            if (Array.isArray(value)) {
               customers = value;
            } else {
               try {
                  const parsed = JSON.parse(value);
                  customers = Array.isArray(parsed)
                     ? parsed
                     : typeof parsed === "string"
                        ? parsed.split(",")
                        : [parsed];
               } catch {
                  customers = value.split(",");
               }
            }

            // Clean up whitespace
            customers = customers.map((name) => name.trim()).filter(Boolean);

            // Group into subarrays of 3
            const grouped = [];
            for (let i = 0; i < customers.length; i += 3) {
               grouped.push(customers.slice(i, i + 3));
            }

            // Render 3 per line
            return (
               <div style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.6" }}>
                  {grouped.map((group, index) => (
                     <div key={index}>{group.join(", ")}</div>
                  ))}
               </div>
            );
         },
      },
      {
         title: "Edit",
         key: "action",
         render: data => (
            <Space>
               <Tooltip title="Edit">
                  <Button
                     shape="circle"
                     className="border-0"
                     icon={<EditOutlined style={{ color: "blue" }} />}
                     onClick={() => {
                        setType("edit");
                        setIsAddModal(true);
                        setEditId(data);
                        reset({
                           ...data,
                        });
                     }}
                  />
               </Tooltip>

            </Space>
         ),
      },
      {
         title: "Review Boxes",
         key: "Review Boxes",
         align: "center",
         render: data => (
            <Space>
               <Tooltip title="Review Boxes">
                  <Button
                     shape="circle"
                     className="border-20"
                     icon={<ArrowRightOutlined style={{ color: "blue" }} />}
                     onClick={() => navigate(`/add-preprocess/${window.btoa(data?.id)}`)}
                  />
               </Tooltip>
            </Space>
         ),
      },
      {
         title: "Print Unique Labels",
         key: "Print Unique Labels",
         align: "center",
         render: data => (
            <Space>
               <Tooltip title="Print Unique Labels">
                  <Button
                     shape="circle"
                     className="border-20"
                     icon={<PrinterOutlined style={{ color: "blue" }} />}
                     onClick={() => handleDownloadBarcodeExcel(data?.id)}
                  // onClick={() => navigate(`/add-preprocess/${window.btoa(data?.id)}`)}
                  />
               </Tooltip>
            </Space>
         ),
      },
   ];


   const userColumns = [
      {
         title: "Created At",
         dataIndex: "created_at",
         key: "created_at",
         render: (created_at) =>
            moment(created_at).tz("America/New_York").format("MM-DD-YYYY hh:mm A"),
         align: "center",
      },
      {
         title: "No of Boxes",
         dataIndex: "input_number", // Ensure the correct key
         key: "input_number",
         align: "center",
      },


      {
         title: "Assigned Boxes",
         dataIndex: "is_completed",
         key: "completed_data",
         align: "center",
         render: (_, record) => `${record.is_completed || 0} / ${record.input_number || 0}`,
      },
      {
         title: "Assign",
         key: "Assign",
         align: "center",
         render: data => (
            <Space>
               <Tooltip title="Assign">
                  <Button
                     shape="circle"
                     className="border-20"
                     icon={<ArrowRightOutlined style={{ color: "blue" }} />}
                     onClick={() => navigate(`/add-preprocess/${window.btoa(data?.id)}`)}
                  />
               </Tooltip>
            </Space>
         ),
      },
   ];

   const fileTypeColumns = [
      {
         title: "Serial No",
         dataIndex: "file_type", // Ensure the correct key
         key: "file_type",
         render: (_, record, index) => index + 1,
         align: "center",
      },
      {
         title: "File Type",
         dataIndex: "file_type", // Ensure the correct key
         key: "file_type",
         align: "center",
      },
      {
         title: "Action",
         key: "action",
         render: (data) => (
            <>
               <Tooltip title="Edit">
                  <Button
                     shape="circle"
                     className="border-0"
                     icon={<EditOutlined style={{ color: "blue" }} />}

                     onClick={() => {
                        setEditingFileType(data);
                        setIsEditingFile(true);
                        setAddFileModal(true);
                        setFileValue("file_type", data.file_type); // Pre-populate the form
                     }}
                  />

               </Tooltip>
            </>

         ),
      }
   ]
   const handleSearch = () => {
      const payloadData = {
         query: searchText,
      };

      // Add pickup_date only if selected
      if (searchDate) {
         payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
      }

      navigate(`/add-preprocess/all?query=${searchText}&pickup_date=${payloadData.pickup_date || ''}`);

   };
   const onSubmit = (data) => {
      const selectedCustomer = customerData.find(
         (c) => c.value === data.customer_id
      );
      const customer_name = selectedCustomer?.label;

      if (type === "add") {
         const postData = {
            ...data,
            customer_name, // Add customer name explicitly
         };


         setIsAddModal(false);
         dispatch(addPrepTeamQueue({ postData })); // Dispatch add action
      } else if (type == "edit") {
         const newTotal = (editId.is_completed || 0) + data.input_number;
         console.log(newTotal, "newTotal===");

         // if (newTotal <= editId.is_completed) {
         //    toast.error("Assigned Boxes cannot be greater than No of Boxes");
         //    return setTimeout(() => {
         //       toast.dismiss();
         //    }, 2000);
         // }
         const payload = {
            postData: {
               input_number: newTotal, // Update the total count
               customer_name,
               customer_id: data?.customer_id,
            },
            updateID: editId.id,
         };
         dispatch(updatePrepTeamQueue(payload)); // Dispatch update action
      }
   };

   const onSubmitFile = (data) => {
      const payload = {
         postData: {
            file_type: data.file_type,
            ...(isEditingFile && { id: editingFileType.id }) // Include ID if editing
         }
      };
      dispatch(addFileType({ postData: payload }))
         .then(() => {
            // toast.success(`FileType ${isEditingFile ? 'Updated' : 'Added'} Successfully`);
            handleAddFileClose();
            rest();
            setEditingFileType(null);
            setIsEditingFile(false);
         });
   };
   useEffect(() => {
      if (addFileError) {
         toast.error(addFileErrorMessage);
         return; // Prevents running success block in case both are truthy by mistake
      }

      if (addFileTypeSucess && isEditingFile) {
         toast.success("File Type Updated Successfully");



         // Call getData after showing success toast
         getData();
      }
      else if (addFileTypeSucess && !isEditingFile) {
         toast.success("File Type Added Successfully");
         getData();
      }
   }, [addFileTypeSucess, addFileError, addFileErrorMessage,]);

   const handleAddFileClose = () => {
      setAddFileModal(false);
      setEditingFileType(null);
      setIsEditingFile(false);
      rest();
   }
   const handleClose = () => {
      setFileModal(false)
   }
   const onModalClose = () => {
      reset();
      setEditId(null)
      setIsAddModal(false);
   };
   const onModalOpen = () => {
      reset({ ...PrepTeamQueueSchema });
      setIsAddModal(true);
   };
   const onInputModalClose = () => {
      reset();
      setIsInputModal(false);
   };
   const handleAddFileSubmit = () => {
      handleFileSubmit(onSubmitFile)();
      rest();
   };
   const inputRef = useRef(null);
   useEffect(() => {
      if (addFileMOdal) {

         setTimeout(() => {
            inputRef.current?.focus();
         }, 100);
      }
   }, [addFileMOdal]);
   return (
      <div>
         <Loader loading={prepTeamQueueLoading} />
         <PageHeader HeaderText="Add Boxes" Breadcrumb={[{ name: "Add Boxes" }]} backButtonUrl="" />
         <Card style={{ marginTop: "-28px", }}
            title="Add Boxes"
            extra={
               <>
                  {role_id != 3 && <>
                     <Button style={{ backgroundColor: 'green', color: 'white' }} className=" mr-3" shape="round" onClick={() => {
                        setType("add");
                        onModalOpen(); // Open modal for Add
                     }}>
                        Add Boxes
                     </Button>
                     <Button icon={<EyeOutlined />} style={{ backgroundColor: '#3f4014', color: 'white' }} className=" mr-3" shape="round" onClick={() => navigate(`/add-preprocess/all`)}>
                        View All Boxes
                     </Button>
                     {/* <Button className="primary-btn ml-2" shape="round" type="primary mr-3" onClick={() => setSearchModal(true)} >Search Filter</Button> */}


                  </>}
                  {role_id != 3 && (
                     <>
                        <Button style={{ backgroundColor: '#96743e', color: 'white' }} icon={<FileOutlined />} className=" rounded-5 mr-2" onClick={() => setFileModal(true)}>Document File Types</Button>
                     </>
                  )}
                  {/* <Space size={"middle"} className="my-3">
                     <SearchComponent

                        placeHolder="Search..."
                        onChange={e => {
                           const payloadData = {
                              query: e.target.value,
                           };
                           getData(payloadData);
                        }} />
                  </Space> */}

                  <Modal
                     title={
                        <div style={{ textAlign: "center", width: "100%" }}>
                           {type === "add" ? "Add Pickup / Boxes Received" : "Edit Pickup / Boxes Received"}
                        </div>
                     }
                     centered
                     width={800}
                     open={isAddModal}
                     onOk={handleSubmit(onSubmit)}
                     onCancel={onModalClose}
                     okButtonProps={{
                        className: "primary-btn",
                        shape: "round",
                        icon: <FileDoneOutlined />,
                        disabled: type === "edit" && editId?.customer_id?.length > 1
                     }}
                     okText={type == "add" ? "Save " : "Update"}
                     cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}
                  >
                     <form onSubmit={handleSubmit(onSubmit)}>
                        <Row gutter={[10, 0]} wrap className="p-2">
                           <Col span={12}>
                              <>
                                 {type === "edit" && editId && (
                                    <span style={{ color: "#555" }}>
                                       <b>Total Boxes:</b> {editId?.input_number || 0}{" "}
                                       <br />
                                       {/* <span style={{ margin: "0 5px" }}>⇒</span>
                                       <b>Balance Boxes:</b> {editId?.input_number - (editId?.is_completed || 0)}{" "}
                                       <span style={{ margin: "0 5px" }}>⇒</span> */}
                                       <b>Spec Assigned Boxes:</b> {editId?.is_completed || 0}
                                    </span>
                                 )}
                                 <div style={type === "edit" ? { marginTop: "20px" } : {}}>

                                    <TextInput
                                       ref={inputAutoFocusRef}
                                       name="input_number"
                                       control={control}
                                       label={type == "edit" ? "Editable Boxes" : "No of Boxes"}
                                       placeholder="Enter No of Boxes"
                                       errors={errors}
                                       required={true}
                                       disabled={editId?.customer_id?.length > 1}
                                    />
                                 </div>
                              </>
                           </Col>
                           <Col style={type === "edit" ? { marginTop: "62px" } : {}} span={12}>
                              <SelectInput
                                 name="customer_id"
                                 control={control}
                                 label="Customer Name"
                                 placeholder="Select customer name"
                                 options={customerData}
                                 errors={errors}
                                 required={true}
                                 mode={type == "edit" && editId?.customer_id?.length > 1 ? "multiple" : ""}
                                 disabled={editId?.customer_id?.length > 1}
                              />

                           </Col>
                        </Row>
                        {editId?.customer_id.length > 1 && (
                           <span style={{ color: 'red' }}>
                              You cannot edit multiple customers in this view because their boxes cannot be matched correctly. Please update each customer based on their unique boxes in the <b>Review Boxes</b> step. The changes will be updated here automatically.

                           </span>
                        )}
                     </form>
                  </Modal>
                  <Modal
                     title={"Assign"}
                     centered
                     className="w-50"
                     open={isInputModal}
                     onOk={handleSubmit(onSubmit)}
                     onCancel={onInputModalClose}
                     okButtonProps={{
                        className: "primary-btn",
                        shape: "round",
                        icon: <FileDoneOutlined />,
                     }}
                     okText={type === "add" ? "Save" : "Update"}
                     cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}
                  >
                     <form onSubmit={handleSubmit(onSubmit)}>
                        <Row gutter={[10, 0]} wrap className="p-2">
                           {Array.from({ length: inputNumberValue }, (_, i) => (
                              <React.Fragment key={i}>
                                 <Col span={12}>
                                    <SelectInput
                                       ref={inputAutoFocusRef}
                                       name={`input_number_${i}`} // Unique name for each input field
                                       control={control}
                                       label={`Box Number ${i + 1}`}
                                       placeholder="Enter Box Number"
                                       options={specIdData}
                                       errors={errors}
                                       required={true}
                                    />
                                 </Col>
                              </React.Fragment>
                           ))}
                        </Row>
                     </form>
                  </Modal>
                  <Modal
                     open={fileModal}
                     onCancel={handleClose}
                     width={700}
                     footer={null}
                  >
                     <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                        <Button className="primary-btn" onClick={() => {
                           setAddFileModal(true);
                           setFileValue("file_type", ""); // Clear the form field
                        }}>
                           Add File Type
                        </Button>
                     </div>

                     <TableComponent columns={role_id == 1 || role_id == 2 ? fileTypeColumns : ""} dataSource={tableFileData} TotalDataCount={counts} size={"small"} onChangeDispatch={getData} />

                  </Modal>
               </>
            }
         >
            <Modal open={addFileMOdal}
               onCancel={handleAddFileClose}
               onOk={handleAddFileSubmit}
               title={
                  <>
                     {isEditingFile ? "Edit File Type" : "Add File Type"}{" "}
                     <span style={{ color: "red" }}>*</span>
                  </>
               } >
               <form onSubmit={handleFileSubmit(onSubmitFile)}>
                  <Row gutter={[10, 0]} wrap className="p-2">
                     <Col span={12}>
                        <Controller
                           name="file_type"
                           control={fileControl}
                           render={({ field }) => (
                              <Input
                                 ref={inputRef}
                                 autoFocus
                                 {...field}
                                 placeholder="Enter File Type"

                              />
                           )}
                        />
                        {fileErrors.file_type && (
                           <p style={{ color: 'red' }}>{fileErrors.file_type.message}</p>
                        )}
                     </Col>
                  </Row>
               </form>
            </Modal>
            <Modal
               open={searchModal}
               onCancel={() => setSearchModal(false)}
               // footer={null}
               onOk={handleSearch}
               okText="Search"
               title={
                  <span>
                     Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                     <hr />
                  </span>

               }
               width={600}
            >

               <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', }}>

                  {/* First Line: Spec or Customer Name */}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Search by Spec or Customer</label>
                     <Input
                        placeholder="Enter Spec or Customer Name"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                     />
                  </div>

                  {/* Second Line: Pickup Date */}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Pickup Date</label>
                     <DatePicker
                        style={{ width: '100%' }}
                        placeholder="Select Pickup Date"
                        value={searchDate}
                        onChange={(date) => setSearchDate(date)}
                        format="MM/DD/YYYY"
                     />
                  </div>

               </div>

            </Modal>
            <TableComponent columns={role_id == 1 || role_id == 2 ? columns : userColumns} dataSource={tableData} TotalDataCount={totalCount} size={"small"} onChangeDispatch={getData} />
         </Card>
      </div>
   );
};

export default PrepTeamQueue;
